import * as Immutable from "immutable";
export default class Viewport {
  constructor(center, zoom) {
    this._value = { center, zoom };
  }
  get center() {
    return this._value.center;
  }
  get zoom() {
    return this._value.zoom;
  }
  toBuilder() {
    const { center, zoom } = this._value;
    return new Builder(Immutable.Map({ center, zoom }));
  }
  static create(center, zoom) {
    return new Viewport(center, zoom);
  }
  toJSON() {
    const { center, zoom } = this._value;
    return {
      center_x: center[0],
      center_y: center[1],
      zoom
    };
  }
  static fromJSON(value) {
    const { center_x, center_y, zoom } = value;
    return Viewport.create([center_x, center_y], zoom);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  center(value) {
    return new Builder(this.value.set("center", value));
  }
  zoom(value) {
    return new Builder(this.value.set("zoom", value));
  }
  build() {
    const { center, zoom } = this.value.toObject();
    return new Viewport(center, zoom);
  }
}
